import angular from 'angular';
import angularInview from 'angular-inview';
import { AngularNewConnectPage } from './pages/connect';

const MODULE_NAME = 'app.connect';

angular.module(MODULE_NAME, [angularInview]).component('esConnectPage', AngularNewConnectPage);

export default MODULE_NAME;
